module.exports = __webpack_public_path__ + "static/panescales-b1613a8c27f73f09a7f05bd96e208c5a.mp4";